import { useContext } from 'react'
import { AuthContext, AuthContextType } from './AuthProvider'

/**
 * Custom hook to access authentication context
 * Provides access to user authentication state and methods
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext)
  
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  
  return context
}

export default useAuth
